import React, { FC } from 'react'
import './styles.scss'
import { IProps } from './types'

export const Avatar: FC<IProps> = ({ url = 'https://s3-us-west-2.amazonaws.com/plann3r.profilepictures/default.png', // TODO: replace with included image
  label = '' }) => {
  return (
    <img
      className="w-12 h-12 rounded-full my-4"
      src={url}
      alt={label}
      title={label}
    />
  )
}
